import React, { Dispatch, FC, SetStateAction, useState } from "react";
import TableHeader, {
    TableHeaderRight,
} from "../../../assets/components/Table/TableHeader";
import {
    Page,
    PaginationBar,
} from "../../../assets/components/PaginationBar/PaginationBar";
import { useAppDispatch, useAppSelector } from "../../../assets/hooks/hooks";
import { hasPermission } from "../../../assets/helpers/helpers";
import { Permissions } from "../../../models/models";
import { LicenseData, LicenseList, TotalLicenses } from "../model";
import RemoveButton from "../../../assets/components/RemoveButton/RemoveButton";
import { useNotification } from "../../../assets/hooks/useNotification";
import { deleteAllKeysText } from "../../../text";
import { getAllIdLicenses } from "../helpers";
import Checkbox from "../../../assets/components/Checkbox/Checkbox";
import { licenseSliceActions } from "../../../redux/license-slice";

interface Props {
    data: LicenseData | undefined;
    dataTable: LicenseList;
    pageNumber: Page;
    currentSizePage: number;
    pageSize: number;
    totalLicenses: TotalLicenses;
    setCurrentPage: Dispatch<SetStateAction<Page>>;
    deleteLicensesHandler: (args: number[]) => void;
}

const LicenseKeysTableHeader: FC<Props> = ({
    data,
    pageSize,
    pageNumber,
    currentSizePage,
    dataTable,
    totalLicenses,
    setCurrentPage,
    deleteLicensesHandler,
}) => {
    const dispatch = useAppDispatch();
    const [isRemoveAll, setRemoveAll] = useState<boolean>(false);
    const { AttentionMessageBox } = useNotification();
    const user = useAppSelector((state) => state.initializeApp);

    const candidatesForRemove = useAppSelector(
        (state) => state.license.candidatesForRemove
    );

    const isAccessPermission = hasPermission(
        user.permissions,
        Permissions.LICENSE_DELETE
    );

    const setAllToRemoveHandler = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        let idList: Partial<number[]> = [];
        setRemoveAll(!isRemoveAll);

        if (data?.detailedInfo) {
            idList = getAllIdLicenses(data.detailedInfo);
        }

        !isRemoveAll
            ? dispatch(licenseSliceActions.addAllCandidates(idList))
            : dispatch(licenseSliceActions.removeAllCandidates());

        return event;
    };

    const deleteAllHandler = () => {
        AttentionMessageBox({
            textContent: deleteAllKeysText(),
        }).then((value) => {
            if (value === "yes") {
                deleteLicensesHandler(candidatesForRemove);
                setRemoveAll(false);
            }
        });
    };

    return (
        <TableHeader
            title="List of licenses"
            dataTableLength={dataTable.length}
            pageSize={currentSizePage}
        >
            <>
                <PaginationBar
                    currentPage={pageNumber as number}
                    currentPageHandler={setCurrentPage}
                    totalItems={totalLicenses}
                    pageSize={pageSize}
                />

                <TableHeaderRight>
                    {dataTable.length && isAccessPermission ? (
                        <div className="license_keys_migrated__header_right">
                            {candidatesForRemove.length ? (
                                <RemoveButton
                                    img="center"
                                    onClick={() => deleteAllHandler()}
                                />
                            ) : null}

                            <Checkbox
                                id="remove_all"
                                name="remove_all"
                                checked={isRemoveAll}
                                value={isRemoveAll.toString()}
                                onChange={setAllToRemoveHandler}
                            />
                        </div>
                    ) : null}
                </TableHeaderRight>
            </>
        </TableHeader>
    );
};

export default LicenseKeysTableHeader;
